import { styled } from '@mui/material/styles'

const PREFIX = 'blogPage'

export const classes = {
  footPrint: `${PREFIX}-footPrint`,
  footPrints: `${PREFIX}-footPrints`,
  footPrintActive: `${PREFIX}-footPrintActive`,
  title: `${PREFIX}-title`,
  author: `${PREFIX}-author`,
  date: `${PREFIX}-date`,
  favoriteClick: `${PREFIX}-favoriteClick`,
  favorite: `${PREFIX}-favorite`,
  line: `${PREFIX}-line`,
  share: `${PREFIX}-share`,
  shareBox: `${PREFIX}-shareBox`,
  icon: `${PREFIX}-icon`,
  cardPrevious: `${PREFIX}-cardPrevious`,
  communityStory: `${PREFIX}-communityStory`,
  cardTitle: `${PREFIX}-cardTitle`,
  cardContent: `${PREFIX}-cardContent`,
  blogFooter: `${PREFIX}-blogFooter`,
  footerTitle: `${PREFIX}-footerTitle`,
  footerContent: `${PREFIX}-footerContent`,
  footerEmail: `${PREFIX}-footerEmail`,
  footerInput: `${PREFIX}-footerInput`,
  footerLabelInput: `${PREFIX}-footerLabelInput`,
  footerButton: `${PREFIX}-footerButton`,
  footerCheckButton: `${PREFIX}-footerCheckButton`,
  thankMsg: `${PREFIX}-thankMsg`,
  uncheckedIcon: `${PREFIX}-uncheckedIcon`,
  checkedIcon: `${PREFIX}-checkedIcon`,
  formControl: `${PREFIX}-formControl`,
  terms: `${PREFIX}-terms`,
  errorWrapper: `${PREFIX}-errorWrapper`,
  errorIcon: `${PREFIX}-errorIcon`,
  errormsg: `${PREFIX}-errormsg`
}

export const Root = styled('div')(({ theme }) => {
  return {
    width: '100%',
    overflow: 'hidden',
    [`& .${classes.footPrint}`]: {
      display: 'inline',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '19.6px',
      color: '#979797',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
        color: '#000000',
        opacity: '25%'
      }
    },
    [`& .${classes.footPrints}`]: {
      display: 'inline',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '19.6px',
      color: '#979797',
      cursor: 'pointer'
    },
    [`& .${classes.footPrintActive}`]: {
      display: 'inline',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '19.6px',
      color: '#415670'
    },
    [`& .${classes.title}`]: {
      fontWeight: '600',
      fontSize: '40px',
      lineHeight: '40px',
      letterSpacing: '-1.8px',
      marginBottom: '21.5px',
      display: 'block',
      marginTop: '24px',
      [theme.breakpoints.down('lg')]: {
        fontSize: '32px'
      }
    },
    [`& .${classes.author}`]: {
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '-0.24px',
      color: 'black'
    },
    [`& .${classes.date}`]: {
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '29px',
      letterSpacing: '-0.2px'
    },
    [`& .${classes.favoriteClick}`]: {
      width: '22px',
      height: '18.33px',
      color: '#F03738',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    [`& .${classes.favorite}`]: {
      width: '22px',
      height: '18.33px',
      color: '#979797',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    [`& .${classes.line}`]: {
      width: '773px',
      height: '1px',
      marginBottom: '44px',
      backgroundColor: '#e8e7e7',
      border: '0',
      [theme.breakpoints.down('lg')]: {
        width: '100%',
        marginBottom: '21px'
      }
    },
    [`& .${classes.share}`]: {
      fontWeight: '700',
      fontSize: '16px',
      width: '55px',
      height: '19px',
      color: '#979797',
      lineHeight: '19.2px',
      wordBreak: 'keep-all'
    },
    [`& .${classes.shareBox}`]: {
      width: '100%',
      height: '24px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '48px'
    },
    [`& .${classes.icon}`]: {
      width: '24px',
      height: '24px'
    },
    [`& .${classes.cardPrevious}`]: {
      fontSize: '24px',
      fontWeight: '600',
      letterSpacing: '-0.4px',
      lineHeight: '33px',
      color: 'rgba(0,0,0,0.25)',
      marginBottom: '24px',
      width: '375.88px'
    },
    [`& .${classes.communityStory}`]: {
      fontWeight: '800',
      fontSize: '12px',
      lineHeight: '14.4px',
      color: 'rgba(0, 0, 0, 0.4)',
      marginBottom: '6px',
      [theme.breakpoints.down('lg')]: {
        width: '100%'
      }
    },
    [`& .${classes.cardTitle}`]: {
      fontWeight: '600',
      fontSize: '22px',
      lineHeight: '24px',
      letterSpacing: '-0.7px',
      color: '#2D3748',
      // width: '177px',
      [theme.breakpoints.down('lg')]: {
        width: '100%',
        fontSize: '18px'
      },
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    [`& .${classes.cardContent}`]: {
      fontWeight: '400',
      fontSize: '16px',
      lineHeight: '29px',
      letterSpacing: '-0.2px',
      [theme.breakpoints.down('lg')]: {
        lineHeight: '24px',
        display: 'flex',
        flexDirection: 'column'
      }
    },
    [`& .${classes.blogFooter}`]: {
      maxWidth: '1180px',
      height: '459px',
      display: 'flex',
      flexDirection: 'row',
      marginTop: '76px',
      marginBottom: '96px',
      backgroundColor: '#F3F3F3',
      borderRadius: '16px',
      [theme.breakpoints.down('md')]: {
        width: '92vw',
        height: 'auto',
        flexDirection: 'column',
        marginBottom: '64px',
        marginTop: '64px'
      }
    },
    [`& .${classes.footerTitle}`]: {
      fontWeight: '600',
      fontSize: '40px',
      lineHeight: '48px',
      letterSpacing: '-1.8px',
      color: 'white',
      width: '82%',
      margin: 'auto',
      [theme.breakpoints.down('md')]: {
        width: '79vw',
        fontSize: '32px',
        letterSpacing: '-1.4px',
        lineHeight: '38.4px'
      }
    },
    [`& .${classes.footerContent}`]: {
      fontWeight: '500',
      fontSize: '18px',
      lineHeight: '27px',
      letterSpacing: '-0.5px',
      color: 'white',
      marginTop: '24px',
      width: '82%',
      margin: 'auto',
      [theme.breakpoints.down('md')]: {
        width: '79vw',
        marginTop: '24px'
      }
    },
    [`& .${classes.footerEmail}`]: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      marginTop: '40px',
      gap: '16px',
      alignItems: 'flex-end',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        marginTop: '24px',
        alignItems: 'center'
      }
    },
    [`& .${classes.footerInput}`]: {
      border: '1px solid #FFFFFF',
      height: '56px',
      width: '100%',
      color: '#FFFFFF',
      '&.Mui-error': {
        background: 'transparent'
      },
      [theme.breakpoints.down('md')]: {
        margin: 'auto',
        // width: '79vw',
        background: 'rgba(255, 255, 255, 0.2)'
      }
    },
    [`& .${classes.footerLabelInput}`]: {
      color: '#FFFFFF',
      '&.Mui-focused': {
        color: '#FFFFFF',
        '&.Mui-error': {
          color: '#F03738'
        }
      }
    },
    [`& .${classes.footerButton}`]: {
      background: 'white',
      color: '#636363',
      width: '148px',
      height: '56px',
      borderRadius: '30px',
      marginLeft: '18px',
      marginBottom: '0px',
      verticalAlign: 'top',
      marginTop: '16px',
      padding: '12px, 36px, 12px, 36px',
      fontSize: '16px',
      fontWeight: '700',
      '&:hover': {
        boxShadow: '0px 16px 32px rgba(249, 170, 30, 0.2)',
        color: '#415670',
        border: 'white',
        backgroundColor: '#DB872C'
      },
      [theme.breakpoints.down('md')]: {
        marginLeft: '0px',
        marginBottom: '40px',
        marginTop: '18px'
      }
    },
    [`& .${classes.footerCheckButton}`]: {
      // color: '#636363',
      width: '56px',
      height: '56px',
      // borderRadius: '30px',
      marginLeft: '18px',
      marginBottom: '0px',
      verticalAlign: 'top',
      marginTop: '16px',
      padding: '12px, 36px, 12px, 36px',
      fontSize: '16px',
      [theme.breakpoints.down('md')]: {
        marginLeft: '0px',
        marginBottom: '40px',
        marginTop: '18px'
      }
    },
    [`& .${classes.thankMsg}`]: {
      fontSize: 14,
      fontWeight: 600,
      marginTop: 5,
      textAlign: 'left',
      marginBottom: '40px'
    },
    [`& .${classes.uncheckedIcon}`]: {
      borderRadius: 2,
      width: 16,
      height: 16,
      backgroundColor: '#EEEDE9',
      border: '1px solid #415670'
    },
    [`& .${classes.checkedIcon}`]: {
      backgroundColor: '#415670',
      '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: 'url(./imgs/checkedIcon.png)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        content: '""'
      }
    },
    [`& .${classes.formControl}`]: {
      display: 'flex',
      alignItems: 'center'
    },
    [`& .${classes.terms}`]: {
      fontSize: 12,
      letterSpacing: -0.2,
      color: '#636363',
      [theme.breakpoints.down('xl')]: {
        letterSpacing: -0.4
      }
    },
    [`& .${classes.errorWrapper}`]: {
      margin: '5px 0',
      width: '100%',
      textAlign: 'left'
    },
    [`& .${classes.errorIcon}`]: {
      width: 16,
      height: 16,
      marginRight: 5
    },
    [`& .${classes.errormsg}`]: {
      color: 'red',
      fontSize: 12
    }
  }
})
